/** OAuth callback の短命な値はこの module の RAM 内だけで保持する。 */
let pending: { code: string; state: string } | null = null;
export function captureDocuSignCallback() {
  if (window.location.pathname !== '/settings/docusign/callback') return;
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');
  pending = code && state ? { code, state } : null;
  // 認証 guard・lazy load より先に、error 等も含め query 全体を取り除く。
  window.history.replaceState(window.history.state, '', window.location.pathname);
}
export function takeDocuSignCallback() {
  const value = pending;
  pending = null;
  return value;
}
export function isOfficialDocuSignAuthorizationUrl(
  value: string,
  environment: 'demo' | 'production' | null | undefined,
) {
  if (!environment) return false;
  try {
    const url = new URL(value);
    return (
      url.origin ===
        (environment === 'demo'
          ? 'https://account-d.docusign.com'
          : 'https://account.docusign.com') &&
      url.pathname === '/oauth/auth' &&
      !url.username &&
      !url.password &&
      !url.hash
    );
  } catch {
    return false;
  }
}
